import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { router, queryClient } from "./router";
import "./styles.css";

// ADR-001 #13 — SPA entry. Mounts React + RouterProvider in the browser.
// MSW only runs in dev mode and only when VITE_USE_REAL_API is not set —
// production builds skip the worker entirely (import.meta.env.DEV is false).

async function bootstrap() {
  if (import.meta.env.DEV) {
    const { startWorker } = await import("./mocks/browser");
    await startWorker();
  }

  const rootEl = document.getElementById("root");
  if (!rootEl) {
    throw new Error("Root element #root not found in index.html");
  }

  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </React.StrictMode>,
  );
}

bootstrap().catch((err) => {
  console.error("[main] bootstrap failed:", err);
});
